import React, { createContext, useContext, useEffect, useState } from "react";

export const MaintenanceContext = createContext(undefined);

const MaintenanceProvider = ({ children }) => {
  const [isMaintenance, setIsMaintenance] = useState(null);

  useEffect(() => {
    fetch("maintenance.json", { cache: "no-store" })
      .then((res) => res.json())
      .then((data) => {
        setIsMaintenance(data.maintenance);
      });
  }, []);

  return (
    <MaintenanceContext.Provider value={isMaintenance}>
      {children}
    </MaintenanceContext.Provider>
  );
};

export const useMaintenance = () => {
  return useContext(MaintenanceContext);
};

export default MaintenanceProvider;
